module.exports = __webpack_public_path__ + "img/title-svg.1b0776dd.png";